<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>

          <b-navbar-brand center>Freight Invoice For Billing</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button style="font-size: 0.675rem ;margin-left: 5px" @click="
                  proceedAssignmentProforma(
                    ffInvoiceModal.allModuleId,
                    0,
                    ffInvoiceModal.jobNo
                  )
                " size="sm" class="ml-1" variant="outline-info">Proceed To Proforma</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div>
              <div class="box" v-if="PreviousPerformaList.length > 0">
                <div class="box-body row">
                  <div class="col-md-2" v-for="(pre_item, pre_index) in PreviousPerformaList" :key="pre_index">
                    <b-button style="font-size: 0.675rem" class="mt-2" v-if="pre_item.profarmaSeries" size="sm"
                      @click="getPreviousTallyData(pre_item)" variant="info">
                      <b>{{ pre_item.profarmaSeries }}</b>
                    </b-button>
                  </div>
                </div>
              </div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Job No.</label>
                    <b-form-input :formatter="capitalizeAll" disabled id="clientName" name="clientName"
                      v-model="ffInvoiceModal.jobNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Date</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientName"
                  disabled
                  name="clientName"
                  v-model="ffInvoiceModal.invDate"
                ></b-form-input>
              </md-layout>
                </md-layout>-->
                <!-- {{ffInvoiceModal}} -->
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="containerTypeId">Invoice Status</label>
                  <model-list-select :list="invoiceStatusList" v-model="ffInvoiceModal.invoiceStatus" option-value="inv"
                    option-text="int" placeholder="Select Status"></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Client Name</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.clientName"></b-form-input>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Client Contact</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.contact"
                    ></b-form-input>
                  </md-layout>
                </md-layout>-->
              </md-layout>
              <!-- <md-layout md-gutter class="gutr">
              
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Address</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="ffInvoiceModal.adress"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>-->
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Departure Airport</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POR"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Destination Airport</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POD"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>SB No/ BOE</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.BOE"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>AWB No</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.blNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Weight (KGS)/ CBM</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.weight"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Airline Name</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.shippingLine"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <div class="mt-3" v-if="packageDetails.length > 0">
                <h5>
                  <b-badge>Package Details</b-badge>
                </h5>

                <!-- /.box-header -->
                <div>
                  <table id="portLocationNew" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.no</th>

                        <th>Client Name</th>

                        <th>No.of Package</th>

                        <th>Package Length</th>

                        <th>Package Width</th>

                        <th>Package Height</th>

                        <th>Unit</th>

                        <th>Package Volume</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item1, index) in packageDetails" :key="index">
                        <td>{{ index + 1 }}</td>

                        <td>{{ item1.clientName }}</td>

                        <td>{{ item1.noOfPackage }}</td>

                        <td>{{ item1.packageLength }}</td>

                        <td>{{ item1.packageWidth }}</td>

                        <td>{{ item1.packageHeight }}</td>

                        <td>{{ item1.packageUnit }}</td>

                        <td>{{ item1.packageVolume }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="mt-3">
                <h5>
                  <b-badge>Charges</b-badge>
                </h5>
                <div>
                  <table id="quotationDetail" class="table table-dark">
                    <thead>
                      <tr>
                        <th>
                          <b-button size="sm" variant="success" @click="addQuotationFields">
                            <!-- @click="addQuotationFields" -->
                            <md-icon>add</md-icon>
                          </b-button>
                        </th>

                        <th>Particulars</th>

                        <th>Quantity</th>
                        <th>Quotation Rate</th>
                        <th>Selling Rate</th>
                        <th>Exch Rate</th>
                        <th>Invoice Amount(Without Taxes)</th>
                        <th>Currency</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                        <td>
                          <b-button size="sm" variant="danger" @click="removeCol(index)">
                            <md-icon>remove</md-icon>
                          </b-button>
                        </td>
                        <!-- <td>{{index+1}}</td> -->
                        <td>
                          <model-list-select 
                      
                            :list="$store.getters['common/getAllLedgerList']" 
                            v-model="item.ffType"
                            option-value="ledger" 
                            option-text="ledger" 
                            placeholder="Select Particular">
                            </model-list-select>
                          <!-- <model-list-select :list="ledgerData" v-model="item.ffType" option-value="ledger"
                            option-text="ledger" placeholder="Select Type"></model-list-select> -->

                          <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.mainffId!=''?true:false" v-model="item.ffType"></b-form-input> -->
                        </td>

                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.quantity"></b-form-input>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.ffSellingRate"></b-form-input>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.sellingRateFinal"></b-form-input>
                        </td>
                        <td>
                          <!-- :disabled="item.ffSellingRate==''?true:false" -->
                          <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                            v-model="item.exchRate"></b-form-input>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" v-model="item.invAmount"></b-form-input>
                        </td>
                        <td>
                          <model-list-select :list="currencyList" v-model="item.currency" option-value="currencyV"
                            option-text="currencyT" placeholder="Select"></model-list-select>
                        </td>
                        <td>
                          <b-form-input :formatter="capitalizeAll" v-model="item.remark"></b-form-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
              </md-layout>-->
              <!-- /.box-body -->
              <md-layout md-gutter class="mrgtop-2per gutr">
                <md-layout md-flex="30">
                  <!-- :disabled="DisableSubmit=='0'?true:false" -->
                  <b-button class="mt-3" :disabled="
                      DisableSubmit == '0' &&
                      $store.getters['common/getAllSuccessInvoiceTB']
                        .InvoiceTypeKeyFlag == true
                        ? true
                        : false
                    " v-if="validateTally == false" variant="primary" @click="submitInvoice('1')"
                    id="addButtonLoader">{{
                    ffInvoiceModal.invoiceStatus == "0"
                    ? "Submit To Billing"
                    : "Save & Submit"
                    }}</b-button>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                  <span style="padding-top: 25px; padding-left: 20px">
                    Last Updated At :
                    <span style="font-weight: bold">{{ updatedTime }}</span> , By :
                    <span style="font-weight: bold">{{ username }}</span>
                    <br />
                    <div v-if="
                        $store.getters['common/getAllSuccessInvoiceTB']
                          .BillingSeriesDataString
                      ">
                      Invoice No.
                      <span style="color: red">{{
                        $store.getters["common/getAllSuccessInvoiceTB"]
                        .BillingSeriesDataString
                        }}</span>
                      genrated.
                      <span v-if="
                          $store.getters['common/getAllSuccessInvoiceTB']
                            .InvoiceTypeKeyFlag == true
                        ">Cannot be re-submitted</span>
                    </div>
                  </span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="15">
                  <b-button :disabled="DisableSubmit == '0' ? true : false" v-if="validateTally == true" variant="dark"
                    class="mt-3" @click="submitInvoice('2')">Send For Approval</b-button>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="80"></md-layout>
            <md-layout md-flex="20">
            
              <md-button
                class="md-raised md-primary md-button-color"
                @click="ProceedBilling"
              >Proceed To Billing</md-button>
            </md-layout>
              </md-layout>-->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopMaxPer"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType:this.$route.query.JobType,
        ShipmentType:this.$route.query.ShipmentType,
        ModuleType:this.$route.query.ModuleType,
        isLedgerActive:'1',
      })
    );
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/airFreightInvoice");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      updatedTime: "",
      username: "",
      PreviousPerformaList: [],
      selectDateFormat,
      containerTypeDetailFactory: [],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "0",
          int: "Closed",
        },
      ],
      validateTally: false,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ledgerData: [],
      packageDetails: [],
      containerMasterData: [],
      ffInvoiceModal: {
        airOrSea: "1",
        AirPkg: "",
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),
        invoiceStatus: "1",
        chnageApprovalStatus: "",
        InvTallyId: "",
        invDate: "",
        jobNo: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        BOE: "",

        clientName: "",
        contact: "",
        adress: "",
        DestiAir: "",
        LP: "",
        POR: "",
        POD: "",
        FPOD: "",
        DepartAir: "",

        containerDetails: [],
        multipleContainerType: [],
        multiConNo: [],
        shippingLine: "",
      },
      DisableSubmit: "",
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    CustomLoader,
  },

  computed: {},
  methods: {
    ProceedBilling() {
      this.$router.push({
        path: "/allModuleForm/billing",
      });
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });
      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // console.log(
      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );
      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    getFinalAmount(ind) {
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseInt(this.ffTallyInvoiceData[ind].quantity) *
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);
      if (
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) <
        parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)
      ) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // let count = 0;
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },
    submitInvoice(id) {
      console.log("this.ffTallyInvoiceData=>", this.ffTallyInvoiceData);
      for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
        // if (!this.ffTallyInvoiceData[r].ffType) {
        if (
          !this.ffTallyInvoiceData[r].currency ||
          !this.ffTallyInvoiceData[r].exchRate ||
          !this.ffTallyInvoiceData[r].ffSellingRate ||
          !this.ffTallyInvoiceData[r].ffType ||
          !this.ffTallyInvoiceData[r].invAmount ||
          !this.ffTallyInvoiceData[r].quantity ||
          !this.ffTallyInvoiceData[r].sellingRateFinal
        ) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].currency) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].exchRate) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].ffSellingRate) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].ffType) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].invAmount) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else {
          console.log("All fields are Entered");
        }
      }
      this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;
      this.ffInvoiceModal["buttonId"] = id;
      let total = 0;

      this.ffTallyInvoiceData.map((x) => {
        let dummy = parseInt(x.invAmount) + total;
        total = dummy;
      });

      this.ffInvoiceModal.totalAmount = total;
      // console.log(this.ffInvoiceModal);
      // return false;
      if (this.validateInvoice != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addInvoiceTallyFF.php`,
          data: JSON.stringify(this.ffInvoiceModal),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    addQuotationFields() {
      let tableFields = {
        ffType: "",

        quantity: "",
        ffSellingRate: "",
        sellingRateFinal: "",
        exchRate: "",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: "",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    getData() {
      this.isLoading = true;
      this.ffTallyInvoiceData = [];
      let type_Size = {
        itemCode: "itemCode",
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),
        //  ffExecutionId: this.$sessionsStorage.get("editAirExecutionId")
        // ffBookingId: this.$sessionsStorage.get("editFFBookingId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirExport/getDataAirExportInvoice.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];
            let QUN = [];
            let EXRT = [];
            let CON_NO = [];
            let CONTYPE = [];
            if (data.PreviousPerformaList.length > 0) {
              this.PreviousPerformaList = data.PreviousPerformaList;
            }
            if (data.tallyTableData.length > 0) {
              this.updatedTime = data.tallyTableData[0].updateTime;
              if (data.tallyTableData[0].editUserId || data.tallyTableData[0].userId) {
                let type_Size = {
                  userId:
                    data.tallyTableData[0].editUserId || data.tallyTableData[0].userId,
                };
                let options = {
                  method: "POST",
                  url: `${URL_BASE}/getUser.php`,
                  data: JSON.stringify(type_Size),
                  crossDomain: true,
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.$sessionsStorage.get("loginId"),
                  },
                };
                axios(options)
                  .then((result) => {
                    const { statusText, status, data } = result;
                    console.log("Hello", result);
                    this.username = data.user[0].username;
                  })
                  .catch((err) => console.log(`Error: ${err}`));
              }
              this.DisableSubmit = data.tallyTableData[0].invoiceStatus;
              Object.keys(data.tallyTableData[0]).map((x) => {
                if (x == "particulars") {
                  if (data.tallyTableData[0][x] != null) {
                    TParti = data.tallyTableData[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.tallyTableData[0][x] != null) {
                    TSelO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.tallyTableData[0][x] != null) {
                    TSF = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.tallyTableData[0][x] != null) {
                    TINV = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "exchRate") {
                  if (data.tallyTableData[0][x] != null) {
                    EXRT = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    EXRT = [];
                  }
                } else if (x == "currency") {
                  if (data.tallyTableData[0][x] != null) {
                    TCUR = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCUR = [];
                  }
                } else if (x == "remark") {
                  if (data.tallyTableData[0][x] != null) {
                    TRE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.tallyTableData[0][x] != null) {
                    QUN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else {
                  this.ffInvoiceModal[x] = data.tallyTableData[0][x] || "";
                }
              });
              if (data.SBVoyageBlData.length > 0) {
                this.ffInvoiceModal.shipperInvNo = data.SBVoyageBlData[0].shiperInv;
                this.ffInvoiceModal.shipperInvDate = data.SBVoyageBlData[0].shiperInvDate;
                this.ffInvoiceModal.blNo = data.SBVoyageBlData[0].MAWBNumber;
                this.ffInvoiceModal.BOE =
                  data.SBVoyageBlData[0].SBNO + " / " + data.SBVoyageBlData[0].sBDate;
              }
              if (TParti.length > 0) {
                TParti.map((x, index) => {
                  let obj = {
                    ffType: x,
                    quantity: QUN[index],
                    ffSellingRate: TSelO[index],
                    sellingRateFinal: TSF[index],
                    exchRate: EXRT[index],
                    invAmount: TINV[index],
                    currency: TCUR[index],
                    remark: TRE[index],
                  };

                  this.ffTallyInvoiceData.push(obj);
                });
              }
            } else {
              this.ffInvSummaryData = data.ffInvSummaryData;
              this.ffInvoiceModal.clientName = data.ffInvSummaryData[0].clientName;
              this.ffInvoiceModal.contact = data.ffInvSummaryData[0].kycContact;
              this.ffInvoiceModal.adress = data.ffInvSummaryData[0].corporateAddress;

              this.ffInvoiceModal.jobNo = data.ffInvSummaryData[0].airFFExportSeries;

              this.ffInvoiceModal.POR = data.ffInvSummaryData[0].departAirport;
              if (data.SBVoyageBlData.length > 0) {
                this.ffInvoiceModal.shipperInvNo = data.SBVoyageBlData[0].shiperInv;
                this.ffInvoiceModal.shipperInvDate = data.SBVoyageBlData[0].shiperInvDate;
                this.ffInvoiceModal.blNo = data.SBVoyageBlData[0].MAWBNumber;
                this.ffInvoiceModal.BOE =
                  data.SBVoyageBlData[0].SBNO + " / " + data.SBVoyageBlData[0].sBDate;
              }

              this.ffInvoiceModal.LP = data.ffInvSummaryData[0].departAirport;
              this.ffInvoiceModal.POD = data.ffInvSummaryData[0].destiAirport;

              this.ffInvoiceModal.allModuleId = data.ffInvSummaryData[0].allModuleId;
              this.ffInvoiceModal.airFcExportId = data.ffInvSummaryData[0].airFcExportId;
              this.ffInvoiceModal.ccTypeExImp = data.ffInvSummaryData[0].transportType;
              this.ffInvoiceModal.shippingLine = data.ffInvSummaryData[0].airlineName;

              if (data.quotationData.length > 0) {
                this.ffTallyInvoiceData = data.quotationData;
              } else {
                this.ffTallyInvoiceData = [];
              }
            }
            // console.log(data);
            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.packageDetailCargo.length > 0) {
              this.packageDetails = data.packageDetailCargo;
            } else {
              this.packageDetails = [];
            }

            this.isLoading = false;
            console.log("this.ffInvoiceModal=>",this.ffInvoiceModal)
          }
        })
        .catch((error) => {});
    },
    getPreviousTallyData(pre_item) {
      console.log("pre_item=>", pre_item);
      // this.ffInvoiceModal.fromAgentColoderTable = pre_item.fromAgentColoderTable;
      // this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      // this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      // this.ffInvoiceModal.profarmaLocationId = pre_item.profarmaLocationId;
      // this.ffInvoiceModal.profarmaLocationName = pre_item.profarmaLocationName;
      // this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      // this.ffInvoiceModal.shipperInvDateforTally = pre_item.shipperInvDateforTally;
      // this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      // this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      // this.ffInvoiceModal.stateName = pre_item.stateName;
      // this.ffInvoiceModal.clientgst = pre_item.clientgst;
      // this.ffInvoiceModal.grnNo = pre_item.grnNo;
      // this.ffInvoiceModal.pickup = pre_item.pickup;
      // this.ffInvoiceModal.Handover = pre_item.Handover;
      // this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobNo = pre_item.jobNo;
      // this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      // this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      // this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      // this.ffInvoiceModal.weight = pre_item.weight;
      // this.ffInvoiceModal.vessel = pre_item.vessel
      //   ? pre_item.vessel
      //   : this.ffInvoiceModal.vessel;
      // this.ffInvoiceModal.blNo = pre_item.blNo;
      // this.ffInvoiceModal.BOE = pre_item.BOE;
      // this.ffInvoiceModal.clientId = pre_item.clientId;
      // this.ffInvoiceModal.clientName = pre_item.clientName;
      // this.ffInvoiceModal.contact = pre_item.contact;
      // this.ffInvoiceModal.adress = pre_item.adress;
      // this.ffInvoiceModal.POR = pre_item.POR;
      // this.ffInvoiceModal.LP = pre_item.LP;
      // this.ffInvoiceModal.POD = pre_item.POD;
      // this.ffInvoiceModal.FPOD = pre_item.FPOD;
      // this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
      // let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
      // console.log("BLno", BLno);
      // BLno = [...new Set(BLno)];
      // console.log("BLno", BLno);
      // this.ffInvoiceModal.blNo = "";
      // this.ffInvoiceModal.blNo = BLno.join(",");
      // console.log("pre_item", pre_item);
      this.getBillData(pre_item);
    },
    getBillData(item) {
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });
      let TParti = [];
      let TCon = [];
      let TSelO = [];
      let TSF = [];
      let TINV = [];
      let TCUR = [];
      let TRE = [];
      let QUN = [];
      let EXRT = [];
      let CON_NO = [];
      let UN = [];
      let CONTYPE = [];

      if (item.particulars != null) {
        TParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        TCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        QUN = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        TSF = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        TSelO = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.exchRate) {
        EXRT = item.exchRate.split(",");
      }
      if (item.containerDetails) {
        CON_NO = item.containerDetails.split(",") || [];
      } else {
        CON_NO = [];
      }
      if (item.finalRateWithoutTax != null) {
        TINV = item.finalRateWithoutTax.split(",");
      }
      if (item.currency != null) {
        TCUR = item.currency.split(",");
      }
      if (item.remark != null) {
        TRE = item.remark.split(",");
      }

      if (TParti.length > 0) {
        TParti.map((x, index) => {
          let obj1 = {
            ffType: x,
            quantity: QUN[index],
            ffSellingRate: TSelO[index],
            sellingRateFinal: TSF[index],
            exchRate: EXRT[index],
            invAmount: TINV[index],
            currency: TCUR[index],
            remark: TRE[index],
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });
        console.log(this.ffTallyInvoiceData);

        // this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    proceedAssignmentProforma(
      all_module_id,

      isConsolidation,
      mainSalesSeries
    ) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },
    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// airFreightInvoice.vue?13b3914a